/**
 * Created by user on 2020/1/1.
 */

import dotSetValue from 'set-value';
import dotGetValue from 'get-value';

export {
	dotSetValue,
	dotGetValue,
}

export default {
	dotSetValue,
	dotGetValue,
}
